import { render, staticRenderFns } from "./mensagens-automaticas.vue?vue&type=template&id=cd4f1a4e&scoped=true&"
import script from "./mensagens-automaticas.vue?vue&type=script&lang=js&"
export * from "./mensagens-automaticas.vue?vue&type=script&lang=js&"
import style0 from "./mensagens-automaticas.vue?vue&type=style&index=0&id=cd4f1a4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd4f1a4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
